/* global API_URL */

export default (leagueSlug, id) =>
  fetch(`${API_URL}/${leagueSlug}/events/${id}/timeline?rpp=-1`).then(response => response.json());
